const AccountView = Backbone.View.extend({
  className: 'accountForm',
  events: {
    'blur #Email': 'emailRegex',
    'submit .form-horizontal': 'submitForm'
  },
  initialize() {
    this.isValid = true;
  },
  emailRegex(e) {
    const $this = $(e.currentTarget);
    const domain = '@phillips.com';
    const emailRegex = new RegExp(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm);
    const $valField = $this.siblings('.text-danger');
    if ($this.val() !== '') {
      if (emailRegex.test($this.val()) === false || $this.val().toLowerCase().indexOf(domain) === -1) {
        $valField.removeClass('hide');
        $this.addClass('val-danger');
        this.isValid = false;
      } else {
        if (!$valField.hasClass('hide')) {
          $valField.addClass('hide');
        }
        if ($this.hasClass('val-danger')) {
          $this.removeClass('val-danger');
        }
        this.isValid = true;
      }
    }
  }
});

export default AccountView;
